import React from 'react'

import { PageNotFound as PageNotFoundComponent } from '@guiker/error-pages'
import { DirectedSource, usePromotionContext } from '@guiker/promotion-context'
import { FeedbackComponent } from '@guiker/react-framework'

import { useT } from '../../i18n'

export const PageNotFound: React.FC = () => {
  const { tMain } = useT({ screenName: 'screens.home' })
  const { directedSource } = usePromotionContext()

  return (
    <>
      {directedSource === DirectedSource.SPLITSPOT && (
        <FeedbackComponent
          toasterType='info'
          toasterDuration={10000}
          toasterMessage={tMain('promotionBanner')}
          onToasterClose={() => {}}
        />
      )}
      <PageNotFoundComponent />
    </>
  )
}
